export default "__VITE_ASSET__CG1pJXep__"